// Visit The Stimulus Handbook for more details 
// https://stimulusjs.org/handbook/introduction
// 
// This example controller works with specially annotated HTML like:
//
// <div data-controller="hello">
//   <input data-hello-target="name" type="text">
//   <button data-action="click->hello#greet">Greet</button>
// </div>
import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [ "email", "submit" ]

  connect() {
    this.emailTarget.focus()
    super.connect()
  }

  loading() {
    this.submitTarget.disabled = true
    this.submitTarget.innerHTML = `
      <svg class="animate-spin inline-block mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
      </svg>
      Iniciando sesión...
    `
    this.submitTarget.classList.add("opacity-75", "cursor-not-allowed")
  }
}
